import React, { Fragment, useContext, useState } from "react";
import { string, array } from "prop-types";

import { Portal } from "../Portal";
import FilterButton from "../FilterButton";
import ResizeContext from "./../../Contexts/ResizeContext";
import { OptionCheckBoxGroup, OptionCheckBox } from "../OptionsCheckBox";

const FilterBar = ({ title, optionGroups }) => {
    const [toggle, setToggle] = useState(false);
    const { isMobile } = useContext(ResizeContext);

    return (
        <Fragment>
            {isMobile && (
                <Portal node="#filter-btn">
                    <FilterButton onClick={() => setToggle(!toggle)} />
                </Portal>
            )}
            <div
                className={`facet-sidebar ${isMobile &&
                    `facet-mobile
                        ${toggle ? "open" : "close"}`}`}>
                {isMobile && (
                    <div
                        className="filter-close"
                        onClick={() => setToggle(!toggle)}>
                        X
                    </div>
                )}
                <h2 className="title h1-clone" key="sidebar-title">
                    {title}
                </h2>
                <div className="sidebar">
                    <div className="options">
                        {optionGroups &&
                            optionGroups.map((optionGroup, index) => (
                                <OptionCheckBoxGroup
                                    key={index}
                                    title={
                                        optionGroup.title
                                            ? optionGroup.title
                                            : `Group ${index}`
                                    }>
                                    {optionGroup.options &&
                                        Array.isArray(optionGroup.options) &&
                                        optionGroup.options.length > 0 &&
                                        optionGroup.options.map(option => (
                                            <OptionCheckBox
                                                key={option.name}
                                                name={option.name}
                                                value={option.value}
                                            />
                                        ))}
                                </OptionCheckBoxGroup>
                            ))}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

FilterBar.propTypes = {
    title: string,
    optionGroups: array
};

export default FilterBar;
